import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navigation } from '../../widgets/Navigation/ui/Navigation';
import styled from 'styled-components';
import { BurgerMenu } from '../../widgets/BurgerMenu/ui/BurgerMenu';

const LayoutWrapper = styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background: #EDF2F7;
`;

const ContentWrapper = styled.main`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 20px;
    max-width: 1280px;
    width: 100%;
    margin: 0 auto;
`;

const TestLayout: React.FC = () => {
  return (
    <LayoutWrapper>
      <BurgerMenu/>
      <ContentWrapper>
      <Navigation/>
        <Outlet />
      </ContentWrapper>
    </LayoutWrapper>
  );
};

export default TestLayout; 